// 课后拓展 异步操作
import  * as api from  '@/api/khExpand';
import * as TYPES from './type';

export default {
  async getExpandWord(context,{paramets,cb}){
    const result = await api.reqExpandWord(paramets);
    context.commit(TYPES.WORK_LIST,result);
    //console.log(result) 
    cb && cb()
  },
  async delDelWork(context,{paramets,cb}){
    const result = await api.reqDelWork(paramets);
    context.commit(TYPES.DEL_WORK,result)
    //console.log(result)
    cb && cb()
  },
  async delDelWorkList(context,{paramets,cb}){
    const result = await api.reqDelWorkList(paramets);
    context.commit(TYPES.DEL_WORK_LIST,result)
    //console.log(result)
    cb && cb()
  },
  async editWorkList(context,{paramets,cb}){
    const result = await api.reqEditWork(paramets);
    context.commit(TYPES.EDIT_WORK,result)
    //console.log(result)
    cb && cb()
  },
  async addWork(context,{paramets,cb}){
    const result = await api.reqAddWork(paramets);
    context.commit(TYPES.ADD_WORK,result)
    //console.log(result)
    cb && cb()
  },
  async getWorkIdHandle(context,{paramets,cb}){
    const result = await api.reqGetWorkID(paramets);
    context.commit(TYPES.GET_WORK_ID,result)
    //console.log(result)
    cb && cb()
  },
  async getWorkFjHandle(context,{paramets,cb}){
    const result = await api.reqGetWorkFj(paramets);
    context.commit(TYPES.GET_WORK_FJ,result)
    //console.log(result)
    cb && cb()
  },
  async submitWork(context,{paramets,cb}){
    const result = await api.reqPostWork(paramets);
    context.commit(TYPES.POST_WORK,result)
    //console.log(result)
    cb && cb()
  },
  async getWorkTopic(context,{paramets,cb}){
    const result = await api.reqGetWorkTopic(paramets);
    context.commit(TYPES.GET_WOEK_TOPIC,result)
    //console.log(result)
    cb && cb()
  },
  async getNotSubmit(context,{paramets,cb}){
    const result = await api.reqGetNotSubmit(paramets);
    context.commit(TYPES.GET_NOT_SUBMIT,result)
    //console.log(result)
    cb && cb()
  },
  async getNotSubmitTotal(context,{paramets,cb}){
    const result = await api.reqGetNotSubmitTotal(paramets);
    context.commit(TYPES.GET_NOT_SUBMIT_TOTAL,result)
    //console.log(result)
    cb && cb()
  },
  async getIdScoring(context,{paramets,cb}){
    const result = await api.reqIdGetScoring(paramets);
    context.commit(TYPES.GET_ID_SCORING,result)
    //console.log(result)
    cb && cb()
  },
  async getIdScoringFj(context,{paramets,cb}){
    const result = await api.reqIdGetScoringFj(paramets);
    context.commit(TYPES.GET_ID_SCORING_FJ,result)
    //console.log(result)
    cb && cb()
  },
  async editIdScoring(context,{paramets,cb}){
    const result = await api.reqIdEditScoring(paramets);
    context.commit(TYPES.EDIT_ID_SCORING,result)
    //console.log(result)
    cb && cb()
  },
  async editTestScoring(context,{paramets,cb}){
    const result = await api.reqEditTestScoring(paramets);
    context.commit(TYPES.EDIT_EDIT_SCORING,result)
    //console.log(result)
    cb && cb()
  },
  async batchScoringTotal(context,{paramets,cb}){
    const result = await api.reqBatchTotal(paramets);
    context.commit(TYPES.BATCH_TOTAL,result)
    //console.log(result)
    cb && cb()
  },
  async batchScoringReject(context,{paramets,cb}){
    const result = await api.reqBatchReject(paramets);
    context.commit(TYPES.BATCH_REJECT,result)
    //console.log(result)
    cb && cb()
  },
  async exportExcel(context,{paramets,cb}){
    const result = await api.reqExportExcel(paramets);
    context.commit(TYPES.EXPORT_EXCEL,result)
    //console.log(result)
    cb && cb()
  },
  async postRemindStudent(context,{paramets,cb}){
    const result = await api.reqRemindStudent(paramets);
    context.commit(TYPES.REMIND_STUDENT,result)
    //console.log(result)
    cb && cb()
  },
  async postHomeworkTestAdd ({ commit, state }, {paramets, cb}) {
    const result = await api.reqHomeworkTestAdd(paramets)
    commit(TYPES.SET_HOMEWORK_INFO, { result, type: 'addTest' })
    cb && cb()
  },
  async getHomeworkTestById ({ commit, state }, {paramets, cb}) {
    const result = await api.reqHomeworkTestById(paramets)
    commit(TYPES.SET_HOMEWORK_INFO, { result, type: 'addById' })
    cb && cb()
  },
  async putHomeworkTestEdit ({ commit, state }, {paramets, cb}) {
    const result = await api.reqHomeworkTestEdit(paramets)
    commit(TYPES.SET_HOMEWORK_INFO, { result, type: 'addEdit' })
    cb && cb()
  },
}